import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { createThemeObject, codesandboxLightTheme } from "../themes";
import { injectThemeStyleSheet } from "../utils/domUtils";
var SandpackThemeContext = React.createContext({
  theme: codesandboxLightTheme,
  id: "codesandbox-light"
});

var SandpackThemeProvider = function SandpackThemeProvider(props) {
  var _createThemeObject = createThemeObject(props.theme),
      theme = _createThemeObject.theme,
      id = _createThemeObject.id;

  var c = useClasser("sp"); // If theme is not explicitly set, don't inject any stylesheet

  if (props.theme) {
    injectThemeStyleSheet(theme, id);
  }

  return React.createElement(SandpackThemeContext.Provider, {
    value: {
      theme: theme,
      id: id
    }
  }, React.createElement("div", {
    className: c("wrapper", id)
  }, props.children));
};

var SandpackThemeConsumer = SandpackThemeContext.Consumer;
export { SandpackThemeProvider, SandpackThemeConsumer, SandpackThemeContext };